'use strict'
import { initState } from './state'
import { has, get } from 'lodash-es'
import { Toast } from 'vant'
import Loader from '@/utils/loader'

const actions = {
  // 取得关注的用户
  async getMyFollowedUser ({ state, rootGetters, commit }, { page = 1, pageSize = 20, uid }) {
    Loader.loading()
    const params = {
      page,
      page_size: pageSize,
      ta_uid: uid
    }
    const { getMyFollowedUserAPI } = await import('@/api/')
    const response = await getMyFollowedUserAPI(params)
    Loader.cancel()
    if (response?.body?.list) {
      const result = {
        list: response.body.list || [],
        pageSize, // 一页几笔
        total: +response.body.page_info.total, // 总笔数
        page: response.body.page_info.current_page, // 第几页
        pages: response.body.page_info.pages, // 总页数
      }
      // H5 需要拼贴结果
      if (rootGetters.isH5View) {
        const collageList = result.page === 1 ? result.list : [ ...state.myFollowedUser.list, ...result.list]
        commit('setMyFollowedUser', {
          ...result,
          list: collageList
        })
      } else {
        commit('setMyFollowedUser', result)
      }
      return result
    } else {
      // TODO: 错误处理
      // Toast({
      //   message: response.head.errMsg,
      // })
      return response.head
    }
  },
  // 取得关注的话题
  async getMyFollowedTopic ({ state, rootGetters, commit }, { page = 1, pageSize = 20, uid }) {
    Loader.loading()
    const params = {
      page,
      page_size: pageSize,
      ta_uid: uid
    }
    const { getMyFollowedTopicAPI } = await import('@/api/')
    const response = await getMyFollowedTopicAPI(params)
    Loader.cancel()
    if (response?.body?.list) {
      const result = {
        list: response.body.list || [],
        pageSize, // 一页几笔
        total: +response.body.page_info.total, // 总笔数
        page: response.body.page_info.current_page, // 第几页
        pages: response.body.page_info.pages, // 总页数
      }
      // H5 需要拼贴结果
      if (rootGetters.isH5View) {
        const collageList = result.page === 1 ? result.list : [ ...state.myFollowedTopic.list, ...result.list]
        commit('setMyFollowedTopic', {
          ...result,
          list: collageList
        })
      } else {
        commit('setMyFollowedTopic', result)
      }
      return result
    } else {
      // TODO: 错误处理
      // Toast({
      //   message: response.head.errMsg,
      // })
      return response.head
    }
  },

  // 关注用户
  async followUser ({ state, rootState, dispatch, commit }, { uid = '', index = -1 } = {}) {
    // 需要登入
    if (!rootState.user.isLogin) {
      dispatch('common/showLoginBox', {}, { root: true })
      return
    }
    if (!uid || index < 0) return
    Loader.loading()
    const { followUserAPI } = await import('@/api/')
    const response = await followUserAPI({ fuid: uid })
    Loader.cancel()
    // 0=成功，1=失败，-1=未登录
    if (response?.body?.status === 0) {
      Toast({
        message: '已成功关注',
      })
      const data = state.myFollowedUser
      data.list.splice(index, 1)
      commit('setMyFollowedUser', data)
      return true
    }
    else if (response?.body?.msg) {
      Toast({
        message: response.body.msg,
      })
      return false
    }
  },

  // 取消关注用户
  async cancelFollowUser ({ state, rootState, dispatch, commit }, { uid = '', index = -1 } = {}) {
    // 需要登入
    if (!rootState.user.isLogin) {
      dispatch('common/showLoginBox', {}, { root: true })
      return
    }
    if (!uid || index < 0) return
    Loader.loading()
    const { cancelFollowUserAPI } = await import('@/api/')
    const response = await cancelFollowUserAPI({ fuid: uid })
    Loader.cancel()
    // 0=成功，1=失败，-1=未登录
    if (response?.body?.status === 0) {
      Toast({
        message: '已取消关注',
      })
      const data = state.myFollowedUser
      data.list.splice(index, 1)
      commit('setMyFollowedUser', data)
      return true
    }
    else if (response?.body?.msg) {
      Toast({
        message: response.body.msg, className:'toast-container'
      })
      return false
    }
  },

  // 关注话题
  async followTopic ({ rootState, dispatch, commit }, topic_id = '') {
    // 需要登入
    if (!rootState.user.isLogin) {
      dispatch('common/showLoginBox', {}, { root: true })
      return
    }
    if (!topic_id) return
    Loader.loading()
    const { followTopicAPI } = await import('@/api/')
    const response = await followTopicAPI({ topic_id })
    Loader.cancel()
    // 0=成功，1=失败，-1=未登录
    if (response?.body?.status === 0) {
      Toast({
        message: '关注成功',
      })
      commit('topic/setTopicInfo', { follow_status: 1 }, { root: true })
    }
    else if (response?.body?.msg) {
      Toast({
        message: response.body.msg,
      })
    }
  },

  // 取消关注话题
  async cancelFollowTopic ({ rootState, dispatch, commit }, topic_id = '') {
    // 需要登入
    if (!rootState.user.isLogin) {
      dispatch('common/showLoginBox', {}, { root: true })
      return
    }
    if (!topic_id) return
    Loader.loading()
    const { cancelFollowTopicAPI } = await import('@/api/')
    const response = await cancelFollowTopicAPI({ topic_id })
    Loader.cancel()
    // 0=成功，1=失败，-1=未登录
    if (response?.body?.status === 0) {
      Toast({
        message: '已取消关注',
      })
      commit('topic/setTopicInfo', { follow_status: 0 }, { root: true })
    }
    else if (response?.body?.msg) {
      Toast({
        message: response.body.msg,
      })
    }
  },
}

export default actions
